import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BookingSlot } from '../../models/booking-slot';
import { environment } from '../../../../../environments/environment';
import { BookingSlotStateService } from '../../services/booking-slot-state.service';
import { Subscription } from 'rxjs';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { BookingSlotSelectPolicyEnum } from '../../services/booking-slot-select-policy.enum';

@Component({
  selector: 'app-time-slot-list',
  templateUrl: './time-slot-list.component.html',
  styleUrls: ['./time-slot-list.component.css']
})
export class TimeSlotListComponent implements OnInit, OnDestroy {

  @Input()
  defaulSlotHeightScale = 6;

  @Input()
  defaultFatorSlotIsFull = 0.95;

  @Output()
  timeSlotSelected: EventEmitter<BookingSlot> = new EventEmitter<BookingSlot>();

  private _changeDateSubscription: Subscription;

  constructor(
    public bookingSlotStateService: BookingSlotStateService,
    public loadingSpinnerService: LoadingSpinnerService,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._unsubscribeChangeDateSubscription();
  }

  get isLoading(): boolean {
    return this.loadingSpinnerService.hasSpinner;
  }

  get isBirthday(): boolean {
    return this.bookingSlotStateService.isBirthday;
  }

  get selectedDate(): Date {
    return this.bookingSlotStateService.selectedDate;
  }

  get maxSlotsCountToShowTime(): number {
    return this.bookingSlotStateService.maxSlotsCountToShowTime;
  }

  get selectedSlot(): BookingSlot {
    return this.bookingSlotStateService.selectedSlot;
  }

  get bookingSlots(): Array<BookingSlot> {
    return this.bookingSlotStateService.bookingSlots;
  }

  // TODO ask if events area single_use freeQuantity or capacity ?
  get displayTimeSlots(): BookingSlot[] {
    return this.bookingSlotStateService.displayTimeSlots;
  }

  get showBookingSlotsDiagram(): boolean {
    return false;
    // return this.bookingSlotStateService.showBookingSlotsDiagram;
  }

  isSlotSelected(slot: BookingSlot): boolean {
    if (!this.selectedSlot) {
      return false;
    }
    return slot.id === this.selectedSlot.id;
  }

  onClickBookingSlot(bookingSlot: BookingSlot) {
    this.bookingSlotStateService.selectedSlot = bookingSlot;
  }

  onClickTimeSlot(timeSlot: BookingSlot) {
    this.timeSlotSelected.emit(timeSlot);
  }

  toTimeString(floatTime: number): string {
    return environment.globalSettings.toTimeString(floatTime);
  }

  isBookingSlotFull(bookingSlot: BookingSlot): boolean {
    return bookingSlot.bookedQuantity / bookingSlot.capacity > this.defaultFatorSlotIsFull;
  }

  getBookingSlotHeight(bookingSlot: BookingSlot): number {
    return bookingSlot.bookedQuantity / bookingSlot.capacity * this.defaulSlotHeightScale;
  }

  nextDayClick() {
    this._unsubscribeChangeDateSubscription();
    this._changeDateSubscription = this.bookingSlotStateService.shiftDay(1).subscribe();
  }

  prevDayClick() {
    this._unsubscribeChangeDateSubscription();
    this._changeDateSubscription = this.bookingSlotStateService.shiftDay(-1).subscribe();
  }

  monthChanged(date: Date) {
    this._unsubscribeChangeDateSubscription();
    const searchDirection = date < this.bookingSlotStateService.selectedDate ? -1 : 1 ;
    this._changeDateSubscription = this.bookingSlotStateService.dateSelect(date, BookingSlotSelectPolicyEnum.FirstSlot, searchDirection).subscribe();
  }

  dateSelected(date: Date) {
    this._unsubscribeChangeDateSubscription();
    this._changeDateSubscription = this.bookingSlotStateService.dateSelect(date).subscribe();
  }

  private _unsubscribeChangeDateSubscription(): void {
    if (this._changeDateSubscription) {
      this._changeDateSubscription.unsubscribe();
      this._changeDateSubscription = null;
    }
  }

  get isShowCalendar(): boolean {
    return !this.bookingSlotStateService?.isPurchaseOnlyTodayTicket;
  }
}
